import { useEffect, useState, useContext, useCallback } from "react";
import { HotelContext } from '../context/hotel'

export function usePersistentState(key, initialValue, ttlMinutes = 10) {
    const { data: { id: hotelId } } = useContext(HotelContext)
    const fullkey = `ViCo::${hotelId}_-_${key}`
    
    const [storedValue, setStoredValue] = useState(() => {
        const now = new Date()
        try {
            const item = window.localStorage.getItem(fullkey)
            let itemParsed = false;
            if (item) {
                itemParsed = JSON.parse(item);
            }
            if (itemParsed?.value && itemParsed?.expiry && now.getTime() < itemParsed.expiry) {
                return itemParsed.value;
            }
            
            // else {
            //     window.localStorage.setItem(fullkey, JSON.stringify({ value: initialValue, expiry: now.getTime() + ttl }))
            //     console.log('2905 - initialValue', initialValue)
            //     setStoredValue(initialValue);
            // }
        } catch (err) {
            console.error(err)
        }

        return initialValue;






        // console.log('2905 - storedValue - state', storedValue)
        // try {
        //     const item = window.localStorage.getItem(fullkey)
        //     if (!item) {
        //         const now = new Date()
        //         window.localStorage.setItem(fullkey, JSON.stringify({ value: initialValue, expiry: now.getTime() + ttl }))
        //         return initialValue;
        //     }
        //     return JSON.parse(item.value);
        // } catch (err) {
        //     console.error(err)
        //     return initialValue
        // }
    })

    useEffect(() => {
        if (storedValue === null) return;
        try {
            const now = new Date()
            const itemStored = window.localStorage.getItem(fullkey)
            let itemStoredParsed = false;
            if (itemStored) {
                itemStoredParsed = JSON.parse(itemStored);
            }
            if (JSON.stringify(itemStoredParsed?.value) !== JSON.stringify(storedValue)) {
                window.localStorage.setItem(fullkey, JSON.stringify({ value: storedValue, expiry: now.getTime() + (ttlMinutes * 60 * 1000) }))
            }
        } catch (err) {
            console.error(err)
        }
    }, [ storedValue ])

    const setPartialStoredValue = useCallback(newData => {
        setStoredValue(actualValue => {
            const result = { ...actualValue, ...newData };
            return result;
        });
    }, [ storedValue ]);

    // useEffect(() => {
    //     const now = new Date()
    //     console.log('2905 - initing...')
    //     try {
    //         const item = window.localStorage.getItem(fullkey)
    //         console.log('2905 - item', item)
    //         let itemParsed = false;
    //         if (item) {
    //             itemParsed = JSON.parse(item);
    //         }
    //         console.log('2905 - item parsed', itemParsed)
    //         console.log('2905 - live - ', now.getTime(), itemParsed.expiry, now.getTime() < itemParsed.expiry)
    //         if (itemParsed?.value && itemParsed?.expiry && now.getTime() < itemParsed.expiry) {
    //             console.log('2905 - item.value', itemParsed.value)
    //             setStoredValue(itemParsed.value);
    //         } else {
    //             setStoredValue(initialValue);
    //         }
            
    //         // else {
    //         //     window.localStorage.setItem(fullkey, JSON.stringify({ value: initialValue, expiry: now.getTime() + ttl }))
    //         //     console.log('2905 - initialValue', initialValue)
    //         //     setStoredValue(initialValue);
    //         // }
    //     } catch (err) {
    //         console.error('2905 - err', err)
    //         setStoredValue(initialValue);
    //     }
    // }, []);

    // Hack para usar desde entornos que estén cacheados ... tipo los callbacks de events
    const getCurrentValueFromStore = () => {
        const itemStored = window.localStorage.getItem(fullkey)
        let itemStoredParsed = false;
        if (itemStored) {
            itemStoredParsed = JSON.parse(itemStored);
        }
        return itemStoredParsed?.value;
    };

    return [ storedValue, setStoredValue, setPartialStoredValue, getCurrentValueFromStore ]
}